<template>
  <div>
    <div class="flex flex-col p-4 items-center">
      <div class="w-full flex flex-row space-x-4 mb-4">
        <div
          class="w-full md:w-1/2 bg-white rounded-lg shadow p-3 flex flex-col items-center justify-center"
          id="report-operations1"
        >
          <h1 class="text-2xl font-semibold mb-2">Órdenes por Día</h1>
          <Chart :options="chartOptions" />
        </div>
        <div
          class="w-full md:w-1/2 bg-white rounded-lg shadow p-3 flex flex-col items-center justify-center"
          id="report-operations2"
        >
          <h1 class="text-lg font-semibold">Tiempo Promedio de Reparación</h1>
          <Chart :options="timeChartOptions" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import numbers from "@/utils/numbers";
import { Chart } from "highcharts-vue";
export default {
  name: "SummaryReports",
  components: {
    Chart,
  },
  props: {
    isMonthly: {
      type: Boolean,
      default: true,
    },
    weekOrders: {
      type: Array,
      required: false,
      default: () => [],
    },
    weekAverageTimeOrders: {
      type: Array,
      required: false,
      default: () => [],
    },
    widthChart: {
      type: Number,
      default: 600,
    },
  },
  data() {
    return {
      chartOptions: {
        chart: {
          type: "column", // Cambia de 'bar' (horizontal) a 'column' (vertical)
          height: 350,
          width: 450,
          reflow: true,
        },
        title: {
          text: null,
        },
        xAxis: {
          categories: this.getCategoriesNames(),
          title: {
            text: "Día de la Semana",
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "Total de Órdenes",
          },
        },
        plotOptions: {
          column: {
            // Cambia 'bar' a 'column'
            color: "#a78bfa",
            dataLabels: {
              enabled: true,
            },
          },
        },
        series: [
          {
            name: "Órdenes",
            data: this.weekOrders,
            color: "#a78bfa",
          },
        ],
      },
      timeChartOptions: {
        chart: {
          type: "line",
          height: 350,
          width: 450,
          reflow: true,
        },
        title: {
          text: null,
        },
        xAxis: {
          categories: this.getCategoriesNames(),
          title: {
            text: "Día de la Semana",
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "Tiempo de Reparación (horas)",
          },
        },
        plotOptions: {
          line: {
            marker: {
              radius: 6,
              symbol: "circle",
              fillColor: "#3b82f6",
            },
            dataLabels: {
              enabled: true,
              format: "{point.y}h",
            },
          },
        },
        series: [
          {
            name: "Tiempo de Reparación",
            data: this.weekAverageTimeOrders,
            color: "#3b82f6",
          },
        ],
      },
    };
  },
  computed: {},
  methods: {
    moneyFormat(value) {
      const { currencySymbol } = this.$store.state.account;
      return numbers.moneyFormat(value, currencySymbol);
    },
    getCategoriesNames() {
      if (!this.isMonthly) {
        return [
          "Lunes",
          "Martes",
          "Miércoles",
          "Jueves",
          "Viernes",
          "Sábado",
          "Domingo",
        ];
      } else {
        return this.weekAverageTimeOrders.map(
          (_, index) => `Semana ${index + 1}`
        );
      }
    },
  },
};
</script>

<style scoped>
.reports-index {
  margin-top: 40px;
}
</style>
